import {createContext} from 'react'

export const SupplierMappingDetails = createContext({
  hasWritePermission: false,

  supplierUsersList: [] as any[],
  isLoading: false,
  filters: {} as any,
  onSearch: (searchValue: string) => {},
  onSortingChange: (key: string, value: string) => {},
  onBrandFilterChange: (values: any) => {},

  allBrands: [] as any[],
  isLoadingAllBrands: false,

  allProducts: [] as any[],
  isLoadingAllProducts: false,
  onSearchProducts: (searchValue: string) => {},
  onPageChangeProducts: () => {},
  productPagination: {} as any,

  onAddProducts: (data: any, setError: any) => {},
  onDeleteProducts: (data: any) => {},
  isOperationLoading: false,

  checkedRows: [] as any[],
  setCheckedRows: (checkedRows: any[]) => {},
})